module.exports = __webpack_public_path__ + "static/img/logo.79b428c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build821/assets/image/common/logo.png
// module id = AMjO
// module chunks = 0 3 32 35